module.exports = __webpack_public_path__ + "static/media/gec.f5948878.png";